import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Horizontal scroll for wide tables without breaking small viewports.
 */
export function ResponsiveTableWrapper({ className, children, ...rest }) {
  return (
    <div
      className={cn(
        'w-full min-w-0 overflow-x-auto rounded-xl sm:rounded-2xl border border-slate-200/80 bg-white shadow-sm',
        '[scrollbar-width:thin] [&::-webkit-scrollbar]:h-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-slate-300/80',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
